import React from 'react';

import { Typography, Button } from '@mui/material';

type Props = {
  isLoading: boolean;
  onClick: () => void;
  text?: string;
};

const SmallEditButton: React.FC<Props> = ({
  isLoading,
  onClick,
  text = 'Edit',
}) => {
  return (
    <Button
      onClick={() => onClick()}
      disabled={isLoading}
      sx={{
        height: '24px',
        borderRadius: '32px',
        marginLeft: '12px',
        marginRight: '12px',
      }}
      color='defaultWhite'
      variant='contained'
      disableElevation
    >
      <Typography noWrap color='darkBlue' fontSize={14}>
        {text}
      </Typography>
    </Button>
  );
};

export default SmallEditButton;
